var _path, _circle, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInterlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2697 17.0413H9.45998C9.41867 17.0413 9.37737 17.0303 9.33981 17.0083L6.15541 15.0873C6.05026 15.0248 6.01271 14.8889 6.07655 14.7861C6.11785 14.72 6.19296 14.6759 6.27557 14.6796H15.0853C15.1266 14.6796 15.1679 14.6906 15.2054 14.7126L18.3898 16.6336C18.495 16.6961 18.5325 16.832 18.4687 16.9348C18.4274 17.0009 18.3523 17.0413 18.2697 17.0413ZM9.52382 16.5969H17.4736L15.0252 15.1167H7.07543L9.52382 16.5969Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7215 9.32066H8.91182C8.87051 9.32066 8.8292 9.30964 8.79165 9.2876L5.611 7.36661C5.5021 7.30417 5.4683 7.16827 5.53214 7.06543C5.57345 6.99564 5.64855 6.95524 5.73117 6.95891H14.5409C14.5822 6.95891 14.6235 6.96993 14.661 6.99197L17.8454 8.91295C17.9543 8.97539 17.9881 9.11129 17.9243 9.21414C17.8792 9.28393 17.8041 9.32433 17.7215 9.32066ZM8.97566 8.87989H16.9254L14.477 7.39967H6.52727L8.97566 8.87989Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8632 11.0359C12.6041 10.7862 12.2548 10.6466 11.8943 10.6466H11.8793C11.1132 10.6907 10.5274 11.3298 10.5725 12.0791C10.6138 12.7733 11.1846 13.3279 11.8943 13.361H11.9093C12.6754 13.3536 13.2913 12.7402 13.2837 11.9909C13.2762 11.6347 13.126 11.2894 12.8632 11.0359Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterlay);
export default __webpack_public_path__ + "static/media/interlay.e855d687f194210733681d607be9ccc6.svg";
export { ForwardRef as ReactComponent };